import type { CleaningTaskDetailResponse, CleaningTaskResponse } from '@/shared/api';

/** Legacy-Mutationskomponenten erhalten dieselbe Task-Form aus dem bereits geladenen Read Model. */
export function cleaningTaskFromDetail(detail: CleaningTaskDetailResponse): CleaningTaskResponse {
  const task = detail.summary;
  return {
    id: task.id,
    propertyId: task.propertyId,
    bookingId: task.bookingId,
    scheduledFor: task.scheduledFor,
    scheduledFrom: `${task.scheduledFromLocalDate}T${task.scheduledFromLocalTime}`,
    scheduledTo:
      task.scheduledToLocalDate && task.scheduledToLocalTime
        ? `${task.scheduledToLocalDate}T${task.scheduledToLocalTime}`
        : null,
    status: task.status,
    assignedToUserId: task.assignedToUserId,
    assignedToUserName: task.assignedToUserName,
    startedAt: task.startedAt,
    completedAt: task.completedAt,
    notes: detail.notes,
    completionNotes: detail.completionNotes,
    items: detail.items,
    photoSlotCount: task.photoSlotCount,
    filledPhotoSlotCount: task.filledPhotoSlotCount,
    photos: detail.photos,
    damages: detail.damages,
  };
}
